import type { IconData } from '@stacksjs/iconify-core'

export const devicesPlug: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M3 0h3v4h4V0h3v4h3v2c0 3.728-2.55 6.86-6 7.748V16H6v-2.252C2.55 12.86 0 9.728 0 6V4h3z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default devicesPlug
